import { Box, Container, Typography } from '@mui/material';
import { PatientsManagement } from 'components/templates';
import React from 'react';
import { useUser } from 'utils/hooks';

export const PatientsView = () => {
  const { isAdmin } = useUser();
  return (
    <Container component="main" maxWidth="xl" sx={{ width: '75%' }}>
      <Box>
        <Typography variant="h4" component="h1" gutterBottom sx={{ textAlign: 'left' }}>
          {!isAdmin ? 'My ' : ''}Patients
        </Typography>
      </Box>
      <PatientsManagement />
    </Container>
  );
};
